import React from 'react';
import './Section1.css';

const Section1 = () => (
  <section className="section1">
    <div className="section1-left">
      <h1>We are an app developer company that creates mobile and web products used and valued by millions of people</h1>
      <button className="cta-btn" onClick={() => {
        const el = document.getElementById('contact');
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }}>Contact Now</button>
    </div>
    <div className="section1-right">
      <img
        src="/hero.webp"
        alt="Analytics and growth illustration"
        className="section1-illustration"
      />
    </div>
  </section>
);

export default Section1;
